Controller.$inject = [];

function Controller() {

}

export function HuiBadgeRing() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            color: '@',
            badgePosition: '@'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `<span class="hui hui-badge-ring"
                              ng-class="['hui-' + ($huiCtrl.color || 'none'),  
                                        'hui-badge-position-' + ($huiCtrl.badgePosition || 'top-end')]"
                              ng-transclude></span>`;
        }
    }
}